const DEFAULT_ZOOM_LEVEL = 14;

export default DEFAULT_ZOOM_LEVEL;
